module.exports = __webpack_public_path__ + "static/media/logo_kicker.d3cf3847.svg";